<template>
    <div>
        
        <div class="brand-opt">
            <el-button @click="handleAddCategoryOtherSet">新增</el-button>
            <el-button type='primary' @click="handleBatchDelete">批量删除</el-button>
        </div>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item>
                    <el-select 
                        v-model="formInline.shopId"
                        placeholder="请选择店铺" 
                        clearable
                        filterable
                        remote
                        width="200px"
                        >
                        <el-option
                            v-for="shopItem in shopList"
                            :key="shopItem.id"
                            :label="shopItem.shortTitle || shopItem.title"
                            style="width: 150px;"
                            :title="shopItem.shortTitle || shopItem.title"
                            :value="shopItem.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="formInline.brandName" placeholder="品牌"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin:16px 0">
            <el-table 
                ref="tableRef" 
                :data="tableData" 
                row-key="distributorCompanyId" 
                width="400px" 
                style="min-height:350px"
                @selection-change="handleSelectionChange"
                :key="tableRefKey"
            >
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="distributorCompanyName" label="品牌">
                    <template slot-scope="{ row }">
                        {{row.brandName}}
                    </template>
                </el-table-column>
                <el-table-column prop="shopId" label="适配店铺">
                    <template slot-scope="{ row }">
                        <div v-if="row.shopNames">
                            <div v-if="row.shopNames.length > 10">
                                <template v-if="!row.expand">
                                    <span
                                        v-for="(item, index) in row.shopNames.slice(0, 10)"
                                        :key="index"
                                    >
                                        <el-image :src="PLATFORMS_ICONS[platform]" fit="fill" class="shop-img"></el-image>
                                        {{item}}
                                    </span>
                                </template>
                                <template v-else>
                                    <span
                                        v-for="(item, index) in row.shopNames"
                                        :key="index"
                                    >
                                        <el-image :src="PLATFORMS_ICONS[platform]" fit="fill" class="shop-img"></el-image>
                                        {{item}}
                                    </span>
                                </template>
                                <span class='row-btn' @click="handleRowExpand(row)">{{ !row.expand ? '...展开' : '收起' }}</span>
                            </div>
                            <div v-else>
                                <span
                                    v-for="(item,index) in row.shopNames"
                                    :key="index"
                                >
                                    <el-image :src="PLATFORMS_ICONS[platform]" fit="fill" class="shop-img"></el-image>
                                    {{item}}
                                </span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="distributorLevel" label="操作">
                    <template slot-scope="{row,$index }">
                        <el-button @click="handleEdit(row,$index)">编辑</el-button>
                        <el-button @click="handleDelete(row,$index)" type='primary'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <AddBrandShopDialog @change="emitChange" :tableData="tableData" :shopList="shopList" ref="brandShopDialogRef"/>
        </div>
    </div>
</template>
<script>
import AddBrandShopDialog from "@components/prod/center/dialogs/AddBrandShopDialog.vue";
import { PLATFORMS_ICONS } from '@/dictionary/platforms';
import { mapGetters, mapActions } from 'vuex'
import { uniqueId, cloneDeep } from 'lodash';

export default {
    props:{
        value:{
            type:Array,
            default:() => {
                return []
            }
        },
        shopList:{
            type:Array,
            default:() => {
                return []
            }
        },
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    inject:['platform'],
    components:{
        AddBrandShopDialog,
    },
    computed:{
        ...mapGetters(['brandConfigTableList'])
    },
    watch:{
        value:{
            handler(newValue, oldValue){
                if(newValue){
                    this.tableData = newValue
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted(){
    },
    data(){
        return {
            formInline:{
                shopId: '',
                brandName: ''
            },
            tableData:[],
            searchParams: {},
            selectedIndices: [],//用户存储选中数据的索引
            PLATFORMS_ICONS,
            tableRefKey: 1,
            searchStatus: false, // 查询状态
        }
    },
    methods:{
        ...mapActions(['setBrandConfig']),
        emitChange(value){
            this.tableData = value
            this.$emit('change', value);
        },
        handleRowExpand(row) {
            row.expand = !Boolean(row.expand)
            this.tableRefKey++
        },
        handleAddCategoryOtherSet(){
            this.$refs.brandShopDialogRef.method_open({
                visibleType:'ADD'
            })
        },
        handleEdit(row,index){
            this.$refs.brandShopDialogRef.method_open({
                visibleType:'EDIT',
                categoryRow: row,
                index,
            })
        },
        handleDelete(row,index){
            var that = this;
            this.$confirm('确认要删除选中的品牌配置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const data = this.tableData.filter(item => {
                    return ![row.id].includes(item.id);
                });
                this.$emit('change', data);
                const brandConfigTableList = cloneDeep(this.brandConfigTableList)
                if (!brandConfigTableList.length) {
                    // 无副本数据则走默认流程，赋值副本数据
                    this.setBrandConfig(data)
                } else {
                    // 有副本数据的情况下，同步删除副本数据中的对应数据
                    const _data = brandConfigTableList.filter(item => {
                        return ![row.id].includes(item.id);
                    });
                    this.setBrandConfig(_data)
                }
                this.tableData = data;
                this.$message({ message: '删除成功', duration: 2000, type: 'success' });
            }).catch(() => {
            //点取消的提示
                return;
            });
        },
        handleBatchDelete() {
            if (!this.selectedIndices.length) {
                return this.$message({ message: '请选择要删除的数据', duration: 2000, type: 'warning' });
            }
            this.$confirm('确认要删除选中的品牌配置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const data = this.tableData.filter(item => !this.selectedIndices.includes(item.id));
                this.$emit('change', data);
                this.tableData = data;
                this.setBrandConfig(data);
                this.selectedIndices = [];
                this.$message({ message: '删除成功', duration: 2000, type: 'success' });
            });
        },
        handleSelectionChange(selection) {
            this.selectedIndices = selection.map(selectedItem => {
                return selectedItem.id
            });
        },
        filteredData(searchParams) {
            const { brandName, shopId } = searchParams;
            const brandConfig = cloneDeep(this.brandConfigTableList);
            let data = brandConfig.length ? brandConfig : this.value;
            this.setBrandConfig(cloneDeep(data));
            return data.filter(item => {
                // 数据格式要统一，因为保存的数据格式是number，所以要匹配对应
                const shopIdMatch = shopId ? item.shopIds.includes(shopId) : true;
                const vBrandNameMatch = brandName ? item.brandName.toLowerCase().includes(brandName.trim().toLowerCase()) : true;
                return shopIdMatch && vBrandNameMatch;
            });
        },
        onSubmit() {
            const searchParams = this.formInline
            this.searchStatus = true
            if(!searchParams.shopId && !searchParams.brandName && this.brandConfigTableList.length) {
                // 参数为空，则查询返回vuex副本数据，重置查询状态为 false
                this.searchStatus = false
                this.tableData = cloneDeep(this.brandConfigTableList)
            } else {
                const res = this.filteredData(searchParams)
                this.tableData = res
            }
        },
        beforeDestroy() {
            this.setBrandConfig([])
        },
    }
    
}
</script>
<style lang="scss" scoped>
.brand-opt{
    margin: 8px 0px;
}
.shop-img {
    // width: 16px;
    height: 16px;
    // border-radius: 50%;
    vertical-align: middle;
}
.row-btn {
    cursor: pointer;
    margin-left: 5px;
    // &:hover {
        color: #396CF3;
    // }
}
</style>